var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authenticated)?_c('a',{staticClass:"logout-button-component",attrs:{"href":_vm.redirect},on:{"click":_vm.logout}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }